<template>
  <div>
    <el-dialog append-to-body
               top="5vh"
               :title="title"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               :close-on-click-modal="false"
               width="500px">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="90px"
               size="small">
        <el-form-item label="学管师："
                      prop="learn_manager">
          <el-select v-model="dataForm.learn_manager"
                     placeholder="请选择学管师"
                     multiple
                     clearable>
            <el-option v-for="(item,index) in $store.state.staffOptions"
                       :key="index"
                       :label="item.nickname"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型："
                      prop="task_stage_type">
          <el-select v-model="dataForm.task_stage_type"
                     style="width:250px"
                     placeholder="请选择状态"
                     clearable>
            <el-option label="代对接"
                       value="51"></el-option>
            <el-option label="匹配中"
                       value="52"></el-option>
            <el-option label="待确认"
                       value="53"></el-option>
            <el-option label="计划中"
                       value="54"></el-option>
            <el-option label="待上课"
                       value="55"></el-option>
            <el-option label="上课中"
                       value="56"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="dataForm.start_time"
                          type="date"
                          value-format="timestamp"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="dataForm.end_time"
                          type="date"
                          value-format="timestamp"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="选择学员">
          <el-tag v-for="tag in chooseList"
                  :key="tag.id"
                  @close="handleClose(tag)"
                  closable>
            {{tag.realname}}
          </el-tag>
          <div style="color:#409EFF"
               @click="chooseStudent">请选择</div>
        </el-form-item>

        <el-form-item label="任务内容">
          <el-input placeholder="请输入任务内容"
                    style="width:250px"
                    type="textarea"
                    v-model="dataForm.task_content"></el-input>
        </el-form-item>

      </el-form>
      <div class="footer">
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
    <studentTable :isVisible="studentDiag"
                  @chooseList="getchooseList"
                  @close="studentDig"></studentTable>
  </div>
</template>

<script>
import { courseAdd, coursePut, bulkCreateTaskFast } from '@/request/api'
import studentTable from '@/components/DialogComponents/studentTable/index.vue'
import { getStorage } from '@/utils/helper'
import { adminUrl } from '@/utils/helper'

export default {
  components: { studentTable },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => {
        return '新建'
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      chooseList: [],
      studentDiag: false,
      dataForm: {
        task_content: '',
      },
      rules: {
        course_name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ],
        // year: [
        //   { required: true, message: '请选择班级课程年份', trigger: 'change' },
        // ],
      },
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    detail: {
      handler(val) {
        if (val) {
          this.$set(this.dataForm, 'course_name', val.course_name)
          this.$set(this.dataForm, 'year', val.year)
          this.$set(this.dataForm, 'status', val.status + '')
          console.log('this.dataForm', this.dataForm)
        }
      },
      // immediate: true,
    },
  },
  methods: {
    studentDig() {
      this.studentDiag = false
    },
    getchooseList(val) {
      this.chooseList = val
    },
    handleClose(tag) {
      this.chooseList.splice(this.chooseList.indexOf(tag), 1)
    },
    emitClose() {
      this.$refs['formRules'].resetFields()
      this.dataForm = {}
      this.$emit('close')
      this.$emit('sumbit')
      this.chooseList = []
    },
    chooseStudent() {
      this.studentDiag = true
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        let student = []
        this.chooseList.map((item) => {
          student.push(item.id)
        })
        if (valid) {
          if (this.title == '新建') {
            let data = []
            this.dataForm.learn_manager.map((item) => {
              data.push({
                learn_manage_id: item * 1,
                task_type: this.dataForm.task_stage_type * 1,
                student_id: student.join(','),
                task_content: this.dataForm.task_content,
                start_time: this.dataForm.start_time,
                end_time: this.dataForm.end_time,
              })
            })
            bulkCreateTaskFast({ arr_data: data }).then((res) => {
              this.emitClose()
            })
          }
        } else {
          console.log('error sxubmit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
}
</style>